import React from "react";
import { Grid, Card, CardContent, Typography, Avatar } from "@mui/material";
import { Person, People, LocalHospital, Medication, Assignment, Vaccines, Event } from "@mui/icons-material";
import TopHeader from "../../components/common/Header/TopHeader";
import ProcurementMenu from "../../components/common/Menu/Procurement";

const ProcurementDashboard = () => {

   const cardsData = [
        {
          title: "Quotations",
          metrics: {
            new: 10,
            total: 150,
            change: "+5%",
          },
          icon: <Person style={{ fontSize: 40, color: "#1976d2" }} />,
        },
        {
          title: "Invoices",
          metrics: {
            new: 25,
            total: 1200,
            change: "+3%",
          },
          icon: <People style={{ fontSize: 40, color: "#388e3c" }} />,
        },
        {
          title: "Purchase Orders",
          metrics: {
            new: 8,
            total: 300,
            change: "-2%",
          },
          icon: <LocalHospital style={{ fontSize: 40, color: "#d32f2f" }} />,
        },

      ];

  return (

    <main id="app">
      <TopHeader />
      <div id="content_wrapper">
        <section className="doctor-management-wrapper bg-white pb-5">
          <ProcurementMenu />

          <div className="container-fluid px-lg-5">
            
            <h2 className="text-center my-5" style={{ fontWeight: "bold", color: "#333" }}>
              Procurement Management Dashboard
            </h2>

            <Grid container spacing={3} className="dashboard-cards-container">
              {cardsData.map((card, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <Card className="dashboard-card" style={{ textAlign: "center", padding: "20px" }}>
                    <Avatar style={{ margin: "0 auto", backgroundColor: "transparent" }}>
                      {card.icon}
                    </Avatar>
                    <CardContent>
                      <Typography variant="h6" component="div">
                        {card.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        New: {card.metrics.new}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Total: {card.metrics.total}
                      </Typography>
                      <Typography variant="body2" color={card.metrics.change.startsWith("+") ? "green" : "red"}>
                        Change: {card.metrics.change}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

          </div>
        </section>
      </div>
    </main>
  );
};

export default ProcurementDashboard;